import { Provider } from '@angular/core'
import { GameSetupConfig, ViewGamesService } from 'game-setup-services'
import { gameSetupConfigToken } from './game-setup-config.token'

export const viewGamesServiceProvider: Provider = {
  provide: ViewGamesService,
  useFactory: (gameSetupConfig: GameSetupConfig): ViewGamesService => {
    return new ViewGamesService(gameSetupConfig)
  },
  deps: [gameSetupConfigToken],
}
